<div id="credentialsModal">
  <dialog-header [centered]="true">
    <div class="credentials-modal-header">
      @if (data.logoUrl) {
        <img
          [src]="data.logoUrl"
          [alt]="data.logoAlt ?? ''"
          class="credentials-modal-logo"
        />
      }
      <span>{{ data.title }}</span>
    </div>
  </dialog-header>
  <mat-dialog-content>
    @if (data.description) {
      <p class="credentials-modal-description">{{ data.description }}</p>
    }
    @for (field of data.fields; track field.key) {
      <div class="form-group tw-mb-4">
        <label
          class="tw-font-semibold tw-block tw-mb-2"
          [for]="'credentialsField_' + field.key"
        >
          {{ field.label }}
          @if (isRequired(field)) {
            <span class="tw-text-red-600" aria-hidden="true">*</span>
          }
        </label>
        <input
          [type]="field.type ?? 'text'"
          class="w-100 form-control"
          [(ngModel)]="values[field.key]"
          [id]="'credentialsField_' + field.key"
          [name]="field.key"
          [placeholder]="field.placeholder"
          [required]="isRequired(field)"
        />
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-4">
    <button type="button" matButton="outlined" (click)="cancel()">
      {{ cancelButtonText }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      id="credentialsModalSubmitButton"
      [disabled]="!canSubmit"
      (click)="submit()"
    >
      {{ primaryButtonText }}
    </button>
  </mat-dialog-actions>
</div>
